// Check if value is a number
// export const isNumber = (value) => isNaN(value) ? 'Must be a Number' : undefined;
export const isNumber = (value) => {
    if (value === null || value === undefined) {
      return undefined; // Allow null or undefined
    }
  
    return isNaN(value) ? 'Must be a Number' : undefined;
  };
  export const isNumberWithOutZero = (value) => {
    if (value === null || value === undefined) {
      return undefined; // Allow null or undefined
    }
    if (Number(value) === 0) {
      return 'Zero is not allowed';
    }
    return isNaN(value) ? 'Must be a Number' : undefined;
  };
// Check if value length is exactly 12 characters
export const mobileNoLength = (value) => value && value.length !== 12 ? 'Must be 12 Digits' : undefined;

// Check if value starts with '9715'
export const mobileNoFormat = (value) =>
    value &&
    (value[0] !== '9' || value[1] !== '7' || value[2] !== '1' || value[3] !== '5')
        ? 'Mobile No. must start with 9715'
        : undefined;

// Validate email format
export const emailErrorRequired = (value) =>
    value && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
        ? undefined
        : 'Please enter a valid Email Id';

export const required = value => value ? undefined : 'Required'

export const pollingIntervalValidation = (value) => {
  if (value === null || value === undefined) {
    return undefined; // Allow null or undefined
  }
  if (isNaN(value)) {
    return 'Must be a Number';
  }
  if (Number(value) === 0) {
    return 'Zero is not allowed';
  }
  if (Number(value) < 10) {
    return 'Minimum value is 10';
  }
  return undefined;
};


/** License No */

export const validateDrivingLicenseNumber = value => {
  if (!value) {
    return 'Driving license number is required';
  }

  // Check if the value is a number and is within the length range
  const isValidLength = value.length >= 6 && value.length <= 8;
  const isNumber = /^\d+$/.test(value);

  if (!isNumber) {
    return 'Driving license number must be numeric';
  }

  return isValidLength ? undefined : 'Driving license number must be between 6 and 8 digits';
};

export const getSubscriptionStatus = (date) => {
  if(date){
  const now = new Date();
  const endDate = new Date(date);
  
  const endOfThisMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0);
  const endOfNextMonth = new Date(now.getFullYear(), now.getMonth() + 2, 0);

  if (endDate < now) {
    return 'expired';
  } else if (endDate <= endOfThisMonth) {
    return 'expiring-this-month';
  } else if (endDate <= endOfNextMonth) {
    return 'expiring-next-month';
  } else {
    return 'active';
  }
}
}

export const validateUaeLandline = (value) => {
  console.log("Validating UAE landline:", value);
  const uaeLandlineRegex = /^(?:\+971|971|0)?[2-9]\d{7}$/;
  if (!value) return undefined;
  return uaeLandlineRegex.test(value) ? undefined : 'Invalid UAE landline number';
};
